import * as React from "react";
import { Collection } from "react-virtualized";
import { weakKey } from "../../../utilities/weakKey";
import { BevPageTypes } from "../BevPageTypes";
import { cellCoordinatesGetter, getDefaultUnit } from "../helpers/bevHelpers";
import { DisplayUnitModal } from "./BevModal";
import { Unit } from "./Unit";
import { bevLabels } from "../constants/generalConstants";
import { SectionContentTitle } from "../../../components/textVariations";

export const Bev = ({
  zoom,
  unit_type_id,
  unitList,
  loading,
  unitTypesList,
  parentDimensions,
  isFacilityMigrated
}: BevPageTypes.TBevComponent) => {
  const collectionRef = React.useRef<any>(null);
  const defaultUnit = getDefaultUnit(unitList, unit_type_id);
  const [selectedUnit, setSelectedUnit] = React.useState<BevPageTypes.TUnit>();
  const [showModal, setShowModal] = React.useState(false);
  const { height: parentHeight, width: parentWidth } = parentDimensions;
  const { notAvailable } = bevLabels;

  React.useEffect(() => {
    const { current: collectionRefObj } = collectionRef;
    if (collectionRefObj) {
      collectionRefObj.recomputeCellSizesAndPositions();
    }
  }, [zoom]);

  // React.useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (defaultUnit) {
  //       const defaultSelectedUnit = document.getElementById(defaultUnit.id);
  //       if (defaultSelectedUnit) {
  //         defaultSelectedUnit.scrollIntoView({
  //           behavior: 'smooth',
  //           block: 'center',
  //         });
  //       }
  //     }
  //   }, 500);
  //   return () => clearTimeout(timer);
  // }, []);

  const clickHandler = (inSelectedUnit: any) => {
    setSelectedUnit(inSelectedUnit);
    setShowModal(true);
  };

  const modalClickHandler = () => {
    setShowModal(false);
    setSelectedUnit(undefined);
  };

  const cellRenderer = ({ index }: { index: number }) => {
    const { [index]: singleUnit } = unitList;
    const unitProps = {
      selectedUnitTypeId: unit_type_id,
      singleUnit: singleUnit,
      zoomValue: zoom,
      clickHandler: clickHandler,
      id: singleUnit.id,
      ...(defaultUnit && { defaultUnitId: defaultUnit.id }),
      ...(selectedUnit && { selectedUnitId: selectedUnit.id }),
      isFacilityMigrated
    };
    return <Unit {...unitProps} key={weakKey({ singleUnit })} />;
  };

  const cellSizeAndPositionGetter = ({ index }: { index: number }) => {
    const { [index]: singleUnit } = unitList;
    return cellCoordinatesGetter(singleUnit, isFacilityMigrated);
  };

  return (
    <>
      {loading ? (
        <></>
      ) : (
        <div className="bevGrid">
          {!defaultUnit && (
            <div className="has-text-centered">
              <SectionContentTitle>
                <span>{notAvailable.heading}</span>
              </SectionContentTitle>
            </div>
          )}
          <Collection
            ref={collectionRef}
            cellCount={unitList.length}
            cellRenderer={cellRenderer}
            cellSizeAndPositionGetter={cellSizeAndPositionGetter}
            height={parentHeight}
            width={parentWidth}
            scrollToAlignment="center"
          />
          <div className={!defaultUnit ? "overlaySection" : "is-hidden"}></div>
          {selectedUnit && (
            <DisplayUnitModal
              showModal={showModal}
              selectedUnit={selectedUnit}
              unitTypesList={unitTypesList}
              clickHandler={modalClickHandler}
            />
          )}
        </div>
      )}
    </>
  );
};
